
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

interface NotificationTypeTableProps {
  typeBreakdown: Array<{
    type: string;
    sent: number;
    deliveryRate: number;
    readRate: number;
  }>;
}

const NotificationTypeTable = ({ typeBreakdown }: NotificationTypeTableProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Performance by Type</CardTitle>
        <CardDescription>Detailed metrics for each notification type</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Type</TableHead>
              <TableHead>Sent</TableHead>
              <TableHead>Delivery Rate</TableHead>
              <TableHead>Read Rate</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {typeBreakdown.map((item) => (
              <TableRow key={item.type}>
                <TableCell className="font-medium">
                  {item.type.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())}
                </TableCell>
                <TableCell>{item.sent}</TableCell>
                <TableCell>
                  <Badge variant={item.deliveryRate > 95 ? "default" : item.deliveryRate > 80 ? "secondary" : "destructive"}>
                    {item.deliveryRate.toFixed(1)}%
                  </Badge>
                </TableCell>
                <TableCell>
                  <Badge variant={item.readRate > 50 ? "default" : item.readRate > 25 ? "secondary" : "destructive"}>
                    {item.readRate.toFixed(1)}%
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default NotificationTypeTable;
